import React from 'react';
import ListingsLayout from '../components/listings/ListingsLayout';

const Products = () => {
    return <ListingsLayout />;
};

export default Products;
